<script setup lang="ts">
import { onMounted, ref } from "vue";
import { Toast } from "bootstrap";

defineProps({
    colorScheme: {
        type: String,
        default: "text-bg-primary",
    },
    placement: {
        type: String,
        default: "bottom-0 end-0"
    },
    showHeader: {
        type: Boolean,
        default: false
    }
});

let toastEle = ref(null);
let thisToastObj : any = null;

onMounted(() => {
    if(toastEle.value) {
        thisToastObj = new Toast(toastEle.value);
    }
});

const _show = () => {
    thisToastObj.show();
}

const _getElement = () => {
    return document.getElementById("proToast");
}

defineExpose({ 
    show: _show,
    getElement: _getElement
});

</script>

<template>
    <div class="toast-container position-fixed p-3" :class="placement">
        <div class="toast align-items-center border-0" :class="[colorScheme]" role="alert" aria-live="assertive" aria-atomic="true" ref="toastEle" id="proToast">
            <div class="d-flex">
                <div class="toast-header" v-if="showHeader">
                    <slot name="header" />
                </div>
                <div class="toast-body">
                    <slot name="body" />
                </div>
                <button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button>
            </div>
        </div>
    </div>
    
</template>